import posthog from 'posthog-js';

const POSTHOG_API_KEY = process.env.REACT_APP_POSTHOG_API_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST;
const isDevelopment = process.env.NODE_ENV === 'development';

if (POSTHOG_API_KEY && typeof window !== 'undefined') {
  
  posthog.init(POSTHOG_API_KEY, {
    api_host: POSTHOG_HOST,
    
    disable_session_recording: isDevelopment,
    autocapture: !isDevelopment,
    capture_pageview: !isDevelopment,
    capture_pageleave: !isDevelopment,
    
    session_recording: !isDevelopment ? {
      maskInputOptions: {
        password: true, 
      },
      recordCanvas: false,
      recordCrossOriginIframes: false,
      sampling: {
        minimumDuration: 0,
        samplingRate: 1,
      },
    } : undefined,
    
    respect_dnt: true,
    
    loaded: (client) => {
      if (isDevelopment) {
        client.debug();
      }
    },
  });
}

export const identifyUser = (userId, properties = {}) => {
  if (userId) {
    posthog.identify(userId, {
      blckbxID: userId,
      ...properties,
    });
    posthog.register({ blckbxID: userId });
  }
};

export const resetUser = () => {
  posthog.reset();
};

export const captureEvent = (eventName, properties = {}) => {
  posthog.capture(eventName, properties);
};

export default posthog;